import { render } from "./mcabecalho.vue?vue&type=template&id=3483e136&scoped=true"
import script from "./mcabecalho.vue?vue&type=script&lang=js"
export * from "./mcabecalho.vue?vue&type=script&lang=js"

import "./mcabecalho.vue?vue&type=style&index=0&id=3483e136&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3483e136"]])

export default __exports__